import { styled, css } from 'styled-components';
import { colors } from '../../../abstracts';
import { drawerBottomBuffer } from '../drawerConsts';
export const DrawerCard = styled.div.withConfig({
  componentId: "aui__sc-1lsd7yd-0"
})(["display:flex;flex-flow:column nowrap;width:100%;max-height:100%;position:relative;", " scroll-behavior:contain;background:", ";border-radius:16px 16px 0px 0px;-moz-border-radius:16px 16px 0px 0px;-webkit-border-radius:16px 16px 0px 0px;overflow:hidden;"], ({
  $stickyActionHeight
}) => $stickyActionHeight ? css(["padding-bottom:calc( ", " + ", "px );"], drawerBottomBuffer.sticky, $stickyActionHeight) : css(["padding-bottom:", ";"], drawerBottomBuffer.default), colors.white);